import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { OdbcDataset } from 'app/model/dataset/odbc.dataset';

import { format } from 'app/shared/utils/string.util';
import { IAttribute } from 'app/model/base/annotation';

@Metamodel.model({
    name: adfModelTypeMap.odbc.copySourceType,
    display: [
        format(stringResources.ModelName_CopySourceTemplate, stringResources.Odbc_DisplayText),
        format(stringResources.ModelName_CopySourcesTemplate, stringResources.Odbc_DisplayText)
    ],
    tags: {
        datasetModel: [
            Metamodel.modelFor(OdbcDataset)
        ]
    }
})
export class OdbcCopySource extends TabularCopySource {
    public static readonly QUERY_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'QUERY_TIMEOUT',
        display: stringResources.ModelName_Source_QueryTimeout_Min,
        accepts: ['String'],
        constraint: {
            minimum: 1,
            maximum: 1440
        }
    })
    public queryTimeout?: number = 120;
}
